var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sendInfor"},[_c('div',{staticClass:"content"},[_c('page-logo'),_vm._v(" "),_c('page-table-list')],1),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }